import React from "react";

import { MenuIds, useMenus } from "../../../hooks/useMenus";
import { AlternativeProductGroup } from "../../../hooks/useAlternativeProducts";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { useSelectedAlternativeProduct } from "../../../hooks/useSelectedAlternativeProduct";
import { useSetAlternativeProduct } from "../../../hooks/useSetAlternativeProduct";
import { useSelectedAlternativeProductGroupState } from "../../bottom-menu-panels/alternative-products/hooks";
import { SidebarPanel } from "../sidebar-panel";
import { AlternativeIcon } from "../../alternative-icon/alternative-icon";
import { SidebarOptions } from "./sidebar-options-list";
import { SvgIcon } from "../../svg-icon";

interface ISidebarAlternativeProductsProps {
	group: AlternativeProductGroup;
}

export function SidebarAlternativeProducts({ group }: ISidebarAlternativeProductsProps) {
	const {
		actions: { setMenu },
	} = useMenus();
	const { createErrorHandler } = useErrorHandling();
	const selectedAlternativeProductCode = useSelectedAlternativeProduct();
	const { setAlternativeProductAsync } = useSetAlternativeProduct();
	const [, setSelectedAlternativeProductGroup] = useSelectedAlternativeProductGroupState();

	const type = group.style === eXpress.core.ListViewStyle.Dropdown ? "list" : "grid";

	return (
		<>
			<SidebarPanel.SubTitle icon={group.icon ? <SvgIcon svgUrl={group.icon} /> : undefined}>
				{group.name}
			</SidebarPanel.SubTitle>
			<SidebarOptions.List type={type}>
				{group.alternativeProducts.map((product) => {
					const icon = product.icon?.svgUrl ? (
						<AlternativeIcon
							className="sidebar-options-panel__alternative-icon"
							svgUrl={product.icon.svgUrl}
							color={product.icon.color}
							overlayColor={product.icon.overlayColor}
							orientation={product.orientation}
						/>
					) : null;

					return (
						<SidebarOptions.Item
							type={type}
							key={product.name}
							title={product.name}
							icon={icon}
							isActive={
								selectedAlternativeProductCode === product.alternativeProductCode
							}
							onClick={() => {
								// Mark Product Group as active menu
								setSelectedAlternativeProductGroup(group);

								// Mark AlternativeProducts Menu as active
								setMenu(MenuIds.AlternativeProducts);

								setAlternativeProductAsync(
									product.alternativeProductCode,
									group,
								).catch(createErrorHandler());
							}}
						/>
					);
				})}
			</SidebarOptions.List>
		</>
	);
}
